import { render, staticRenderFns } from "./EstilloDataManager.vue?vue&type=template&id=05728546&scoped=true&"
import script from "./EstilloDataManager.vue?vue&type=script&lang=js&"
export * from "./EstilloDataManager.vue?vue&type=script&lang=js&"
import style0 from "./EstilloDataManager.vue?vue&type=style&index=0&id=05728546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05728546",
  null
  
)

export default component.exports